import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconBack({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <path
                fill={color}
                fillRule='evenodd'
                d='M10.986 7.514l-4.431 4.515 4.688 4.687c2.578 2.578 5.011 4.363 5.407 3.967.396-.396-1.03-2.511-3.168-4.701L9.594 12l3.703-3.792C15.334 6.122 17 4.097 17 3.708c0-1.614-1.832-.455-6.014 3.806'
            />
        </svg>
    );
}
